<!-- AbsoluteURL (custom mark) -->
<script lang="ts">
	import MdiOpenInNew from '~icons/mdi/open-in-new';

	import type { MarkComponentProps } from '@portabletext/svelte';

	interface Props {
		portableText: MarkComponentProps<{
			href: string;
			blank: boolean;
			documentType: string;
		}>;
		children?: import('svelte').Snippet;
	}

	let { portableText, children }: Props = $props();
</script>

<!-- eslint-disable svelte/no-navigation-without-resolve -->
{#if portableText.value.blank}<a href={portableText.value.href} target="_blank" rel="noreferrer">
		{@render children?.()}
		<MdiOpenInNew class="inline" />
	</a>
{:else}
	<a href={portableText.value.href}>{@render children?.()}</a>
{/if}
